// Module
var code = `<br class="separator"/> <div class="row no-template-found"> <div class="w-100 flex flex-column"> <div class="relative flex justify-center items-center"> <div class="w-30"> <img src="/assets/img/blip-curious.png" class="mb3" height="125px"/> <h4 class="bp-c-rooftop bp-fs-4 fw7 mb2" translate="{{\$ctrl.notFoundMessage}}" translate-values="{
                        searchText: \$ctrl.searchText
                    }"> </h4> </div> </div> </div> </div> `;
// Exports
module.exports = code;